/* 药水计算 */
export const calculationArr = [
  [30, 60, 80, 90, 100, 150, 200, 500, 1000, 2000, 5000], /* 兑水量 */
  [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000] /* 稀释倍数 */
]
